<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<div
    class="tw-pt-[7rem] tw-pb-[5rem] tw-max-w-[1300px] tw-mx-auto tw-px-[20px]"
>
    <div
        class="tw-flex tw-gap-[5px] tw-font-semibold tw-text-[#7B7575] tw-mb-[20px]"
    >
        <span (click)="goBack()" class="tw-uppercase tw-cursor-pointer"
            >FAQ</span
        >
        <span>/</span>
        <span class="tw-capitalize tw-text-black">{{
            selectedLanguage === "en" ? categoryNameEn : categoryNameBm
        }}</span>
    </div>
    <div
        class="tw-flex tw-flex-col tw-gap-[20px] tw-mb-[50px] tw-w-full tw-items-start"
    >
        <div
            class="tw-text-[24px] tw-text-[#212121] tw-font-bold lg:tw-font-semibold"
        >
            {{ "COMMON.HOW_CAN_WE_HELP?" | translate }}
        </div>
    </div>
    <ng-container *ngIf="category">
        <app-faq-data
            [category]="category"
            [selectedLanguage]="selectedLanguage"
        ></app-faq-data>
    </ng-container>
</div>

<app-footer></app-footer>
